import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routes from './routes.tsx';

export const usePageMeta = () => {
  const location = useLocation();

  useEffect(() => {
    // Find the current route
    const currentRoute = routes.find(route => {
      if (route.path === '*') return false;
      
      // Handle dynamic routes
      if (route.path.includes(':')) {
        const routePathSegments = route.path.split('/');
        const locationPathSegments = location.pathname.split('/');
        
        if (routePathSegments.length !== locationPathSegments.length) return false;
        
        return routePathSegments.every((segment, index) => {
          if (segment.startsWith(':')) return true;
          return segment === locationPathSegments[index];
        });
      }
      
      return route.path === location.pathname;
    });

    // Update document title
    if (currentRoute?.meta?.title) {
      document.title = currentRoute.meta.title;
    }

    // Update meta description
    if (currentRoute?.meta?.description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', currentRoute.meta.description);
    }

    // Update Open Graph tags
    if (currentRoute?.meta?.title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute('content', currentRoute.meta.title);
    }

    if (currentRoute?.meta?.description) {
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.setAttribute('content', currentRoute.meta.description);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${window.location.origin}${location.pathname}`);

  }, [location.pathname]);
}; 